// Formatting and totalling of AI spend, shared by both clients so a figure
// reads identically wherever it appears.
//
// The backend accumulates costUsd per agent (agentTelemetry.recordAgentRun),
// priced from the rate table in aiPricing.js with any tenant override applied.
// These are estimates for visibility, not a billing source of truth — the
// provider's own invoice is.

function num(v) {
  const n = Number(v);
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

export function agentRunCost(agent) {
  return num(agent?.metrics?.costUsd);
}

export function totalCost(agents = []) {
  return (Array.isArray(agents) ? agents : []).reduce((sum, a) => sum + agentRunCost(a), 0);
}

// Spend here spans several orders of magnitude — a single chat question costs
// a small fraction of a cent, a month of drawing comparison runs into pounds —
// so a fixed number of decimal places is wrong at one end or the other.
// Below a cent it reads as "<$0.01" rather than "$0.00", which would suggest
// the run was free; a "$0.00" for work that did happen is the one output worth
// avoiding.
export function formatCost(usd) {
  const value = num(usd);
  if (value === 0) return '$0.00';
  if (value < 0.01) return '<$0.01';
  if (value < 1000) return `$${value.toFixed(2)}`;
  return `$${Math.round(value).toLocaleString()}`;
}

export function formatTokens(n) {
  const value = num(n);
  if (value < 1000) return String(value);
  if (value < 1_000_000) return `${(value / 1000).toFixed(value < 10_000 ? 1 : 0)}k`;
  return `${(value / 1_000_000).toFixed(1)}M`;
}

// "$2.00 / $8.00 per 1M tokens" - the shape the rate list shows.
export function formatRate(input, output) {
  const fmt = (v) => {
    const n = num(v);
    // Rates run from $0.05 to $75 per million, so trailing precision matters
    // at the cheap end and is noise at the expensive end.
    return n < 1 ? `$${n.toFixed(2)}` : `$${n.toFixed(2)}`;
  };
  return `${fmt(input)} in · ${fmt(output)} out`;
}
